<template>
  <div class="i-echart-wrapper">
    <div :id="id" class="i-echart-box" :style="height ? `height:${height}` : ''"></div>
    <div class="i-echart-x" v-if="options.xAxis.data && options.xAxis.data.length">
      <!-- <span>{{ getChartDate(options.xAxis.data[0]) }}</span> -->
      <!-- <span>{{ getChartDate(options.xAxis.data[options.xAxis.data.length / 2 - 1]) }}</span>
      <span>{{ getChartDate(options.xAxis.data[options.xAxis.data.length / 2]) }}</span> -->
      <!-- <span>{{ getChartDate(options.xAxis.data[options.xAxis.data.length - 1]) }}</span> -->
      <span v-for="(item, index) in options.xAxis.data" :key="index">
        <span v-if="index === 0 || (index === options.xAxis.data.length - 1) || showXAxisLabels.includes(index)">
          {{ getChartDate(item) }}
        </span>
      </span>
    </div>
    <div class="i-title-wrapper"><slot name="title"></slot></div>
    <div class="i-subtitle-wrapper"><slot name="subtitle"></slot></div>
  </div>
</template>
<script>
import * as echarts from 'echarts';

import pointImage from '@/assets/images/index/point.png';
import { getChartDate } from '@/utils/tools/time';

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    height: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'line',
    },
    showXAxisLabels: {
      type: Array,
      default: () => ([]),
    },
  },
  emits: ['on-mouseover'],
  data() {
    return {
      id: `line-chart-${Math.floor(Math.random() * 100000000)}`,
      lineChart: null,
    };
  },
  mounted() {
    const chartDom = document.querySelector(`#${this.id}`);
    this.lineChart = echarts.init(chartDom);
    this.setStyle();
    this.lineChart.setOption(this.options);
    this.lineChart.on('mouseover', (params) => {
      if (params.componentType === 'series') {
        this.$emit('on-mouseover', params);
      }
    });
  },
  watch: {
    'options.series': {
      handler() {
        this.setStyle();
        this.lineChart.setOption(this.options);
      },
      deep: true,
    },
  },
  methods: {
    setStyle() {
      // title样式
      if (this.options.title) {
        this.options.title.textStyle = {
          color: '#264373',
          fontWeight: 600,
          fontSize: 16,
          lineHeight: 22,
        };
        this.options.title.subtextStyle = {
          color: 'rgba(0,32,63,0.6)',
          fontWeight: 'bold',
          fontSize: 14,
          lineHeight: 23,
        };
        this.options.title.left = 20;
        this.options.title.top = 17;
      }
      // x轴样式
      if (this.options.xAxis) {
        // x轴坐标轴两边不留白
        this.options.xAxis.boundaryGap = this.type !== 'line';
        // x轴不显示
        this.options.xAxis.show = false;
        this.options.xAxis.axisLabel = {
          color: '#00203F',
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 17,
        };
        this.options.xAxis.splitLine = {
          show: false,
        };
        // x轴样式
        this.options.xAxis.axisLine = {
          lineStyle: {
            color: '#E8EBEE',
            width: 1,
          },
        };
        this.options.xAxis.nameLocation = 'start';
        // 不显示坐标轴刻度
        this.options.xAxis.axisTick = {
          show: false,
        };
        this.options.xAxis.nameRotate = 180;
      }
      // y轴样式
      if (this.options.yAxis) {
        // 不显示y轴值
        this.options.yAxis.axisLabel = {
          show: false,
        };
        if (this.type === 'bar') {
          this.options.yAxis.splitNumber = 4;
          this.options.yAxis.splitLine = {
            show: true,
            lineStyle: {
              color: '#eeeeeeb2',
            },
          };
        } else {
          this.options.yAxis.splitLine = {
            show: false,
          };
        }
      }
      // tooltip样式
      if (this.type === 'line') {
        this.options.tooltip = {
          ...this.options.tooltip,
          ...{
            showContent: true,
            trigger: 'axis',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            textStyle: {
              color: 'transparent',
              fontSize: 12,
              fontWeight: 400,
              lineHeight: 15,
            },
            axisPointer: {
              type: 'none', // tooltip的虚线不显示
            },
          },
        };
      } else {
        this.options.tooltip = {
          ...this.options.tooltip,
          ...{
            showContent: true,
            trigger: 'axis',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            textStyle: {
              color: 'transparent',
              fontSize: 12,
              fontWeight: 400,
              lineHeight: 15,
            },
            axisPointer: {
              type: 'none', // tooltip的虚线不显示
            },
          },
        };
      }
      this.options.grid = {
        left: 20,
        right: 20,
        bottom: 45,
        top: 95,
      };
      this.options.series[0].type = this.type;
      this.options.series[0].smooth = true;
      this.options.series[0].symbol = `image://${pointImage}`;
      this.options.series[0].symbolSize = 1;
      this.options.series[0].emphasis = {
        scale: 24, // 折线图拐点hover时缩放
      };
      // 拐点颜色
      // this.options.series[0].itemStyle = { color: 'transparent' };
      // 折线颜色
      this.options.series[0].lineStyle = { color: '#00A2DD' };
      // 标记点
      if (this.options.series[0].markPoint) {
        this.options.series[0].markPoint.symbol = `image://${pointImage}`;
        this.options.series[0].markPoint.symbolSize = 24;
        // this.options.series[0].markPoint.animationDuration = 500;
        // this.options.series[0].markPoint.label = { show: true };
      }
      if (this.type === 'bar') {
        this.options.series[0].barMaxWidth = '6';
        this.options.series[0].markPoint.symbol = 'none';
        this.options.series[0].itemStyle = {
          color: '#00A2DD',
          shadowColor: '#b1b1b14c',
        };
      }
    },
    getChartDate,
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/variables.scss';

.i-echart-wrapper {
  position: relative;
  height: 100%;
  box-shadow: 0px 0px 10px 4px rgba(240,240,240,0.5);
  border-radius: 12px;
  .i-echart-box {
    width: 100%;
    height: 250px;
  }
  .i-echart-x {
    position: absolute;
    bottom: 15px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
    width: 100%;
    font-size: 12px;
    font-weight: 500;
    color: #264373;
    line-height: 17px;
  }
  .i-title-wrapper {
    position: absolute;
    color: $color-text-primary;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    top: 17px;
    padding: 0 20px;
    width: 100%;
    box-sizing: border-box;
  }
  .i-subtitle-wrapper {
    position: absolute;
    line-height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0,32,63,0.6);
    line-height: 30px;
    padding: 0 20px;
    width: 100%;
    box-sizing: border-box;
    top: 39px;
  }
}
@media screen and (max-width: 992px) {
  .i-echart-wrapper {
    .i-title-wrapper {
      font-size: 16px;
      font-weight: 800;
    }
    .i-echart-x {
      font-size: 16px;
    }
  }
}

</style>
